var delete_consultation = function(event) {
    event.preventDefault();
    var $target = $(event.target);
    var $container = $target.parents(".js-consultation-container");
    var new_consult = $(".js-consult-id", $container).length;

    if(new_consult) {
        $container.slideUp("normal", function() { $(this).remove(); } );
    } else {
        $(".js-consult-destroy", $container).val(true)
        $container.slideUp();
    }
}

var add_consultation = function() {
  $(".js-add-consultation").on("click", function(event) {
    event.preventDefault();

    var content = $(this).data('partial');
    var new_id = new Date().getTime();
    var input_names = /visit\[consults_attributes\]\[\d+\]/g;
    var input_ids = /visit_consults_attributes_\d+/g;
    content = content.replace(input_names, "visit[consults_attributes][" + new_id + "]");
    content = content.replace(input_ids, "visit_consults_attributes_" + new_id);

    $(".js-consultations-container").append(content);
    if (window.initDatepickers) {
        window.initDatepickers($, $(".js-consultations-container").children().last());
    } else {
        console.error('window.initDatepickers is not defined; datepickers will not initialize on new rows. Ensure legacy.js is loaded before this module.');
    }
  });

  $(".js-consultations-container").on("click", ".js-delete-consultation", delete_consultation);
}

$(document).ready(add_consultation);
$(document).on('page:load', add_consultation)